<template>
  <div>
    <h3 class="title">Hi {{ displayUsername }},</h3>
    <p class="description">Here's what is happening with your business today</p>

    <div style="padding: 20px">
      <a-spin class="spinner" :spinning="loading">
        <a-row style="margin-top:30px" type="flex" justify="space-between">
          <a-col :xs="{ span: 24 }" :md="{ span: 7 }" :lg="{ span: 8 }"
            style="background:#fff; border-radius:6px;border:1px solid #ccc;">
            <a-row type="flex" justify="space-between" align="middle">
              <a-col>
                <div style="padding:20px">
                  <a-statistic title="Total Orders" :value="overalData.totalOrders" />
                </div>
              </a-col>
              <a-col>
                <div style="padding:20px">
                  <div style="display:flex;justify-content: center;width:100%">
                    <img class="img_size" src="../assets/img/filledoutline.png" />
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-col>

          <a-col :xs="{ span: 24 }" :md="{ span: 7, offset: 1 }" :lg="{ span: 7, offset: 1 }"
            style="background:#fff;border-radius:6px;border:1px solid #ccc;">
            <a-row type="flex" justify="space-between" align="middle">
              <a-col>
                <div style="padding:20px">
                  <a-statistic title="Products Sold" :value="overalData.productSold" />
                </div>
              </a-col>
              <a-col>
                <div style="padding:20px">
                  <div style="display:flex;justify-content: center;width:100%">
                    <img class="img_size" src="../assets/img/group_2.png" />
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-col>

          <a-col :xs="{ span: 24 }" :md="{ span: 7, offset: 1 }" :lg="{ span: 7, offset: 1 }"
            style="background:#fff;border-radius:6px;border:1px solid #ccc;">
            <a-row type="flex" justify="space-between" align="middle">
              <a-col>
                <div style="padding:20px">
                  <a-statistic title="Net Sales(Ksh)" :value="overalData.netSales" />
                </div>
              </a-col>
              <a-col>
                <div style="padding:20px">
                  <div style="display:flex;justify-content: center;width:100%">
                    <img class="img_size" src="../assets/img/sales.png" />
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <a-row type="flex" justify="space-between">
          <a-col :span="16">

            <a-col style="background: #fff;border-radius:6px;border:1px solid #ccc;margin-top:30px">
              <div style="padding:10px">
                <p style="color:#40a9ff;font-size: 17px;">Quick Action</p>
                <!-- <div style="display:flex;justify-content:space-between;">
                    
                    <p style="font-size:15px;">490 Pre-Orders</p>
                    <p style="font-size:15px">Awaiting Fulfilment</p>
                    <a style="font-size:15px" href="#">Ship Now</a>
                </div> -->

                <a-row type="flex" justify="space-between" align="middle">
                  <a-col style="text-align:center" class="circle_green" :span="5"></a-col>
                  <a-col style="width:29%" :span="4"> <span>{{ salesOrder.length }}</span> Sales Orders</a-col>
                  <a-col style="width:29%" :span="4">
                    <div @click="redirectUrl"
                      style="cursor:pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      View
                    </div>
                  </a-col>
                </a-row>
                <hr />
                <a-row style="padding-top:10px" type="flex" justify="space-between" align="middle">
                  <a-col class="circle_red" :span="5"></a-col>
                  <a-col style="width:29%" :span="5"> <span>{{ invoiceData }}</span> Invoices</a-col>
                  <a-col style="width:29%" :span="5">
                    <div @click="redirectUrlInvoices"
                      style="cursor:pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      View
                    </div>
                  </a-col>
                </a-row>
                <hr />
                <a-row style="padding-top:10px" type="flex" justify="space-between" align="middle">
                  <a-col class="circle_orange" :span="5"></a-col>
                  <a-col style="width:29%" :span="5"> <span>{{ replenishment.length }}</span> Replenishment</a-col>
                  <a-col style="width:29%" :span="5">
                    <div @click="redirectPurchaseOrder"
                      style="cursor:pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      Replenish
                    </div>
                  </a-col>
                </a-row>
                <hr />
              </div>
            </a-col>

            <a-col style="background: #fff;border-radius:6px;margin-top:30px;border:1px solid #ccc">
              <div style="padding:10px;border-radius: 6px;">
                <div class="actions">
                  <p style="font-size: 17px;color:#40a9ff">Top Products:</p>
                  <div>
                    <a-button @click="exportTopProductExcell"
                      style="height:31px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                      icon="export">
                      Export
                    </a-button>
                    <router-link class="ml-4"
                      style="cursor:pointer;color: #007bff;text-decoration: none;background-color: transparent;"
                      to="/item">View More</router-link>
                  </div>
                </div>

                <div style="padding:10px;">

                  <div style="margin-bottom:50px">
                    <a-table :columns="topProductColumns" :data-source="topProductdata" :pagination="false" size="small"
                      :loading='tableLoading' class="tableStyle">
                    </a-table>
                  </div>
                </div>

              </div>
            </a-col>

            <a-col style="margin-top:30px;background: #fff;margin-bottom: 82px;border-radius:6px;border:1px solid #ccc">
              <div style="padding:10px;">

                <div class="actions">
                  <p style="color:#40a9ff;font-size: 17px;">Daily Sales</p>
                  <div>
                    <a-button @click="exportDailySalesExcell"
                      style="height:31px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                      icon="export">
                      Export
                    </a-button>
                    <router-link class="ml-4"
                      style="cursor:pointer;color: #007bff;text-decoration: none;background-color: transparent;"
                      to="/report">View More</router-link>
                  </div>

                </div>
                <div style="margin-bottom:50px">
                  <a-table :columns="columns" :data-source="tableData" :pagination="{ pageSize: 5 }" size="small"
                    :loading='tableLoading' class="tableStyle">
                  </a-table>
                </div>
              </div>
            </a-col>
          </a-col>
          <a-col style="background: #fff;margin-top:30px;border-radius:6px;border:1px solid #ccc;margin-bottom: 82px;"
            :span="7" :offset="1">
            <div style="padding:10px">
              <p style="color:#40a9ff;font-size: 17px;">Sales Summary</p>
              <a-row style="margin-top:40px" type="flex" justify="space-between">
                <a-col style="color:#888" :span="10">Gross Sales</a-col>
                <a-col style="color:#888" :span="12">{{ overalData.revenue ? overalData.revenue : 'N/A' }}</a-col>
                <a-col style="color:#888;padding-top:20px" :span="10">Cost of Goods</a-col>
                <a-col style="color:#888;padding-top:20px" :span="12">{{ overalData.costOfGoods ? overalData.costOfGoods
      : 'N/A' }}</a-col>

              </a-row>
            </div>

            <div>
              <a-divider type="horizontal" />
            </div>

            <div style="padding:10px;margin-top:10px">
              <p style="color:#40a9ff;font-size: 17px;">Order Summary</p>
              <a-row style="margin-top:8px" type="flex" justify="space-between">
                <a-col style="color:#888" :span="10">Total Orders</a-col>
                <a-col style="color:#888" :span="8">{{ overalData.totalOrders ? overalData.totalOrders : 'N/A'
                  }}</a-col>
                <a-col style="color:#888;padding-top:20px" :span="10">Processing</a-col>
                <a-col style="color:#888;padding-top:20px" :span="8">{{ overalData.processing ? overalData.processing :
                  'N/A' }}</a-col>

              </a-row>
            </div>
          </a-col>
        </a-row>
      </a-spin>

    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import LineChart from './preorder/common/LineChart'
// import PieChart from './preorder/common/PieChart'
// import infiniteScroll from 'vue-infinite-scroll';
// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import _ from 'lodash';
import XLSX from "xlsx";
import moment from 'moment';
const columns = [
  {
    title: 'Date',
    // width: 150,
    dataIndex: 'dailyDate',
    key: 'dailyDate'
  },
  {
    title: 'Quantity',
    dataIndex: 'totalQuantitySold',
    // width: 130,
  },
  {
    title: 'Gross Sales',
    dataIndex: 'totalSales',
    //  width: 50,
  },
  {
    title: 'Cost of Goods',
    dataIndex: 'totalCostPrice',
    // width: 150,
  },
  {
    title: 'Profits',
    dataIndex: 'totalProfit',
    // width: 150,
  }

];

const topProductColumns = [
  {
    title: 'Product Brand Name',
    // width: 150,
    dataIndex: 'productBrandName',
    key: 'productBrandName'
  },
  {
    title: 'Quantity',
    dataIndex: 'totalQuantitySold',
    // width: 130,
  },
  {
    title: 'Gross Sales',
    dataIndex: 'totalSales',
    // width: 130,
  },
  {
    title: 'Cost of Goods',
    dataIndex: 'totalCostPrice',
    // width: 130,
  },
  {
    title: 'Profits',
    dataIndex: 'totalProfit',
    //  width: 50,
  },


];



export default {
  name: "Overview",
  // directives: { infiniteScroll },
  components: {
    // LineChart,
    // PieChart
  },
  computed: {
    ...mapGetters(['IsAgentProfileAvailable', 'getQuickActionCount']),
    displayUsername() {
      // console.log("IsAgentProfileAvailable | ", this.IsAgentProfileAvailable)
      // let userProfile = JSON.parse(this.IsAgentProfileAvailable)
      return this.IsAgentProfileAvailable.name
    },
    displayProductCount() {
      return this.overalData.stockCount
    },

    displaySellingPrice() {
      return parseFloat(this.overalData.estimatedSales).toFixed(2)
    },
    displayProfit() {
      return parseFloat(this.overalData.estimatedProfit).toFixed(2)
    },
    displaySalePrice() {
      return parseFloat(this.overalData.sales).toFixed(2)
    },
    displayCostOfGoodsPrice() {
      return parseFloat(this.overalData.costOfGoods).toFixed(2)
    },
    displaySalesProfit() {
      return parseFloat(this.overalData.profit).toFixed(2)
    },
    displayTodayOrder() {
      return this.todayOrder.productCount
    },
    displayFulfillmentOrder() {
      return this.todayOrder.fulfilledOrders
    },
    pieData() {
      let dataSets = [this.overalData.profit, this.overalData.costOfGoods, this.overalData.sales]
      // console.log("dataSets  1| ", dataSets)
      let value = dataSets.reduce((acc, item) => acc + item, 0);
      // console.log("value | ", value)
      return value === 0 ? false : true
    },
    displayQuickAction() {
      return this.quickActionCount
    }
  },
  data() {
    return {
      dateFormat: 'YYYY-MM-DD',
      startDate: moment().subtract(30, 'd').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      columns,
      topProductColumns,
      tableData: [],
      exportTopProductLoading: false,
      topProductdata: [],
      tableLoading: false,
      listLoading: false,
      loading: false,
      overalData: {
        totalOrders: '',
        productSold: '',
        netSales: ''
      },
      dateRange: "Last Week",
      chartdata: null,
      options: null,
      chartOrderdata: null,
      optionsOrders: null,
      chartOptions: {
        hoverBorderWidth: 20
      },
      salesOrder: [],
      invoiceData: [],
      replenishment: [],
      todayOrder: {},
      chartPieData: null,
      ordersByZone: [],
      quickActionCount: {
        preOrdersCount: 0,
        outOfStockCount: 0,
        lowStockCount: 0,
        campaignCount: 0,
        inventoryWithBal: [],
        inventoryWithOutBal: [],
        livePreOrders: [],
        pendingPreOrders: []
      },
      inventoryWithBal: [],
      inventoryWithOutBal: [],
      livePreOrders: [],
      pendingPreOrders: [],
      redirctData: {}
    }
  },
  methods: {
    ...mapActions(['getOverviewData', 'getPreOrderCampaigns', 'finalAgentInventory', 'setQuickActionInfo', 'setOrderInfo', 'setPreviewDataInfo', 'setPreviewInfo']),
    moment,
    getSalesRevenueReport(reports) {
      // console.log("reports | ", reports)
      let labels = reports.map(report => moment(report.dailyDate).format("DD-MMM"))
      let dataSets = reports.map(report => report.revenue)
      this.chartdata = {
        labels: labels.length > 0 ? labels : ["No Data"],
        datasets: [
          {
            label: 'Revenue',
            borderColor: '#418a49',
            data: dataSets
          }
        ],
      }
      this.options = {
        responsive: true,
        maintainAspectRatio: false
      }
    },
    showLast2Weeek() {
      this.startDate = moment().subtract(14, 'd').format('YYYY-MM-DD'),
        this.endDate = moment().format('YYYY-MM-DD')
      this.dateRange = "Last 2 Weeks"
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);
      let request_data = {
        startDate: this.startDate,
        endDate: this.endDate
      }
      let salesRequest_data = {
        startDate: this.startDate,
        endDate: this.endDate,
        preorderCampaignId: "",
        searchBy: {},
        sortBy: {}
      }
      this.overallData(request_data);
      this.loadSalesReport(salesRequest_data)
    },
    showLastWeeek() {
      this.startDate = moment().subtract(7, 'd').format('YYYY-MM-DD'),
        this.endDate = moment().format('YYYY-MM-DD')
      this.dateRange = "Last Week"
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);
      let request_data = {
        startDate: this.startDate,
        endDate: this.endDate
      }
      let salesRequest_data = {
        startDate: this.startDate,
        endDate: this.endDate,
        preorderCampaignId: "",
        searchBy: {},
        sortBy: {}
      }
      this.overallData(request_data);
      this.loadSalesReport(salesRequest_data)
    },

    exportTopProductExcell() {

      // this.exportTopProductLoading = true
      const dataToExport = [
        [
          "Product Brand Name",
          "Quantity(Ksh)",
          "Gross Sales",
          "Cost of Goods",
          "Profits"
        ],
      ];

      // this.exportTopProductLoading = false;

      this.topProductdata.forEach((v) => {
        dataToExport.push([
          v.productName,
          v.totalQuantitySold,
          v.totalSales,
          v.totalCostPrice,
          v.totalProfit
        ]);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(wb, `Export-Top-Ptoducts-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
      // this.exportTopProductLoading = false;
      this.showSuccessAlert("Data Successfully Exported")
    },

    exportDailySalesExcell() {

      // this.exportTopProductLoading = true
      const dataToExport = [
        [
          "Date",
          "Quantity",
          "Gross Sales",
          "Cost of Goods",
          "Profits"
        ],
      ];

      // this.exportTopProductLoading = false;

      this.tableData.forEach((v) => {
        dataToExport.push([
          v.dailyDate,
          v.totalQuantitySold,
          v.totalSales,
          v.totalCostPrice,
          v.totalProfit
        ]);
      });


      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(wb, `Export-Daily-Sales-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
      this.exportTopProductLoading = false;
      this.showSuccessAlert("Data Successfully Exported")
    },
    getRegionOrdersReport(reports) {
      // console.log("reports | ", reports)

      this.ordersByZone = reports.map(order => ({
        distributionCentreName: order.distributionCentreName,
        value: `Value : ${order.quantityOrdered}`,
        percent: order.quantityOrdered
      }))

      // console.log("ordersByZone | ", this.ordersByZone)

    },
    getPiechartData(report) {
      // console.log("report | ", report)
      let dataSets = [report.profit, report.costOfGoods, report.sales]
      // console.log("dataSets | ", dataSets)
      this.chartPieData = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["Profit", "Cost", "Revenue"],
        datasets: [
          {
            label: "Sales Breakdown",
            backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            data: dataSets.length > 0 ? dataSets : ["No Data"]
          }
        ]
      }
    },
    onChange(date, dateString) {
      // console.log(date, dateString);
      this.startDate = dateString[0];
      this.endDate = dateString[1];
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);
      let request_data = {
        startDate: this.startDate,
        endDate: this.endDate
      }
      let salesRequest_data = {
        startDate: this.startDate,
        endDate: this.endDate,
        preorderCampaignId: "",
        searchBy: {},
        sortBy: {}
      }
      this.overallData(request_data);
      this.loadSalesReport(salesRequest_data)
    },
    overallData(request_data) {
      this.getOverallReport(request_data).then(response => {
        // console.log("response overview |", response)
        if (response.status === 200) {
          this.overalData = response.data;
          // this.getPiechartData(response.data);

        } else {
          console.log('Error | ', response)
        }
      },
        error => {
          // this.tableLoading = false;
          console.log('Error | ', error)
        })
    },
    todayOrderData(request_data) {
      this.getOverallReport(request_data).then(response => {
        // console.log("response today |", response)
        if (response.status === 200) {
          this.todayOrder = response.data;
        } else {
          console.log('Error | ', response)
        }
      },
        error => {
          // this.tableLoading = false;
          console.log('Error | ', error)
        })
    },

    toPercent(number) {
      let percent = parseFloat(number * 100).toFixed(2);
      return percent;
    },
    randomString(length) {
      return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
    },

    showSuccessAlert(message) {
      this.$notification['success']({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification['error']({
        message: message
      });
    },

    loadOverviewData() {
      this.loading = true;
      let finalRequest = {
        request_data_1: {
          startDate: moment().subtract(12, 'months').format('YYYY-MM-DD'), // last 12 months
          endDate: moment().format('YYYY-MM-DD'),
        },
        request_data_2: {
          page: -1,
          perPage: -1,
          searchBy: {},
          sortBy: {}
        },
        request_data_3: {
          startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'), // last 7 days
          endDate: moment().format('YYYY-MM-DD'),
        }
      }

      this.getOverviewData(finalRequest).then(response => {
        this.loading = false;
        let processing = response[0].data.data.filter(product => product.status === 1 || product.status === 2)

        this.overalData = {
          totalOrders: response[0].data.data.length,
          productSold: response[1].data.productCount,
          netSales: response[1].data.netSales.toLocaleString(undefined, { minimumFractionDigits: 2 }),
          costOfGoods: `Ksh ${response[1].data.costOfGoods.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
          revenue: `Ksh ${response[1].data.sales.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
          processing: processing.length
        }

        let result = response[3].data.data.map(product => ({
          key: this.randomString(10),
          dailyDate: moment(product.dailyDate).format('YYYY-MM-DD'),
          totalQuantitySold: product.totalQuantitySold,
          totalSales: product.totalSales.toLocaleString(undefined, { minimumFractionDigits: 2 }),
          totalCostPrice: product.totalCostPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
          totalProfit: product.totalProfit.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }))

        this.tableData = _.reverse(result)

        let topProductsList = response[4].data.data.map(product => ({
          key: product.productId,
          productBrandName: product.productBrandName ? product.productBrandName : "N/A",
          totalQuantitySold: product.totalQuantitySold ? product.totalQuantitySold : 0,
          totalSales: product.totalSales ? product.totalSales : 0.00,
          totalCostPrice: product.totalCostPrice ? product.totalCostPrice : 0.00,
          totalProfit: product.totalProfit ? product.totalProfit : 0.00
        }));

        let sortedTopProductsList = _.orderBy(topProductsList, ['totalSales'], ['desc'])

        this.topProductdata = sortedTopProductsList.slice(0, 5).map(product => ({
          key: product.key,
          productBrandName: product.productBrandName ? product.productBrandName : "N/A",
          totalQuantitySold: product.totalQuantitySold.toLocaleString(undefined, { minimumFractionDigits: 0 }),
          totalSales: product.totalSales.toLocaleString(undefined, { minimumFractionDigits: 2 }),
          totalCostPrice: product.totalCostPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
          totalProfit: product.totalProfit.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }))

      })
    },

    loadQuickActionData() {
      this.loading = true;
      let params = {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {}
      }
      // console.log("initial data in getProducts | ", this.params)
      this.finalAgentInventory(params).then(response => {
        this.loading = false;
        // console.log('response products ', response)
        if (response[0].status !== 200 && response[1].status !== 200) {
          this.showErrorAlert(response.data.messages)
        } else if (response[0].status === 200 && response[1].status === 200) {
          let productsResponse = response[0].data.data
          let inventoryResponse = response[1].data.data
          this.salesOrder = response[3].data.data.filter(order => order.statusLabel === "New")
          this.invoiceData = response[4].data.data.length
          this.replenishment = response[5].data.data.filter(order => order.statusLabel === "New")

          let inventoryIds = inventoryResponse.map(inventory => inventory.productId);

          for (var product of productsResponse) {
            for (var inventory of inventoryResponse) {
              if (product.id === inventory.productId) {
                // console.log("product | ", product)
                let agentInventory = {}
                agentInventory['key'] = product.id

                // agentInventory['thumb'] = product.description
                agentInventory['category'] = product.categoryName
                agentInventory['supplier'] = product.supplierName
                agentInventory['manufacturer'] = product.manufacturerName
                agentInventory['productName'] = product.brandName
                agentInventory['commission'] = product.commission,
                  agentInventory['quantity'] = inventory.balance
                agentInventory['createdAt'] = moment(product.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                agentInventory['price'] = product.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })
                agentInventory['status'] = product.isActive === true ? product.isActive : false
                agentInventory['costPrice'] = product.purchasePrice ? product.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'N/A'
                agentInventory['profitMargin'] = `${product.margin.toFixed(2)}%`
                agentInventory['action'] = product

                this.inventoryWithBal.push(agentInventory)
              }
            }
          }

          for (var product2 of productsResponse) {
            if (!inventoryIds.includes(product2.id)) {
              // console.log("product | ", product)
              let agentInventory = {}
              agentInventory['key'] = product2.id
              // agentInventory['thumb'] = product.description
              agentInventory['category'] = product2.categoryName
              agentInventory['productName'] = product2.brandName
              agentInventory['supplier'] = product2.supplierName
              agentInventory['manufacturer'] = product2.manufacturerName
              agentInventory['commission'] = product.commission,
                agentInventory['quantity'] = 0
              agentInventory['createdAt'] = moment(product2.createdAt).format("DD/MM/YYYY HH:mm:ss A")
              agentInventory['price'] = product2.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })
              agentInventory['status'] = product2.isActive === true ? product2.isActive : false
              agentInventory['costPrice'] = product2.purchasePrice ? product2.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'N/A'
              agentInventory['profitMargin'] = `${product2.margin.toFixed(2)}%`
              agentInventory['action'] = product2

              this.inventoryWithOutBal.push(agentInventory)
            }
          }

          this.quickActionCount = {
            salesOrder: this.salesOrder,
            invoiceData: this.invoiceData,
            replenishment: this.replenishment
          }

          this.setQuickActionInfo(JSON.stringify(this.quickActionCount))
        } else {
          this.loading = false;
          console.log('Error | ', response)
          this.showErrorAlert('Something went wrong, try again later.')
        }

      },
        error => {
          this.loading = false;
          console.log('Error | ', error)
        })
    },
    redirectUrl() {
      this.$router.push('/orders').catch(() => { });
    },
    redirectUrlInvoices() {
      this.$router.push('/invoices').catch(() => { });
    },

    redirectPurchaseOrder() {
      this.$router.push('/inventory-transfer').catch(() => { });
    },

    loadQuickActionCount() {
      this.loadQuickActionData();
    }
  },
  created() {

    if (this.loadOverviewData) {
      this.loadOverviewData()
    }
    if (this.getQuickActionCount) {
      let result = JSON.parse(this.getQuickActionCount)
      this.salesOrder = result.salesOrder,
        this.invoiceData = result.invoiceData,
        this.replenishment = result.replenishment
    } else {
      this.loadQuickActionCount()
    }
  }
}
</script>

<style scoped>
.title {
  margin: 0 auto;
  font-size: 28px;
  line-height: 45px;
  text-align: center;
  color: #000000;
}

.iconLayout {
  text-align: center;
  margin-top: 36px;
  margin-left: 49px;
  padding: 10px;
  font-size: 33px;
  padding-right: -1px;
  border-radius: 46px;
  height: 66px;
  width: 50%;
  color: #418a49;
  background: #e5efe7;
}

.cardAmount {
  font-size: 23px;
  text-align: left;
  color: #4d4f5c;
  padding-top: 14px;
}

.cardInventoryPercentage {
  display: -webkit-box;
  font-size: 11px;
  line-height: 14px;
  text-align: center;
  color: #ff4141;
}

.cardOrdersPercentage {
  display: -webkit-box;
  font-size: 11px;
  line-height: 14px;
  text-align: center;
  color: #3cc480;
}

.description {
  margin: 0 auto;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
}

.card {
  background: #ffffff;
  width: 270px;
  height: 133px;
  border-radius: 6px;
}

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}

.center-screen>>>.ant-statistic-title {
  font-size: 20px;
}

.img_size {
  max-width: 56px;
  max-height: 55px;
  margin: 0 auto;
}

.img_size_2 {
  max-height: 20%;
  max-width: 20%;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}


.tableStyle>>>.ant-table-thead {
  background: #c7c7c763;
  height: 63px;
}

.ant-switch-checked {
  background-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.container1 {
  /* BOTH of the following are required for text-overflow */
  white-space: nowrap;
  overflow: hidden;
  white-space: initial;
  padding-bottom: 20px;
}

.container2 {

  padding: 2px 5px;

  /* BOTH of the following are required for text-overflow */
  white-space: nowrap;
  overflow: hidden;
  white-space: initial;
  padding-bottom: 20px;
}

.demo-infinite-container {
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 250px;
}

.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}

.ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 0;
}

.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 93%;
  min-width: 0%;
  height: 1px;
  /* margin: 24px 0; */
  margin-left: 9px;
  /* margin-right: 19px; */
}

.circle_green {
  width: 25px;
  height: 25px;
  margin-left: 23px;
  background: rgb(83, 233, 70);
  -moz-border-radius: 70px;
  -webkit-border-radius: 70px;
  border-radius: 70px;
}

.circle_red {
  width: 25px;
  height: 25px;
  margin-left: 23px;
  background: red;
  -moz-border-radius: 70px;
  -webkit-border-radius: 70px;
  border-radius: 70px;
}

.circle_orange {
  width: 25px;
  height: 25px;
  margin-left: 23px;
  background: rgb(245, 211, 63);
  -moz-border-radius: 70px;
  -webkit-border-radius: 70px;
  border-radius: 70px;
}

.circle_grey {
  width: 25px;
  height: 25px;
  margin-left: 23px;
  background: rgb(153, 152, 149);
  -moz-border-radius: 70px;
  -webkit-border-radius: 70px;
  border-radius: 70px;
}

.spinner>>>.ant-spin-dot-item {
  background-color: #418a49;
}

/* .ant-col-6 {
    display: block;
    box-sizing: border-box;
    width: 28%;
} */
</style>
